//Componentes generales
import React, { useReducer, useContext, useEffect } from "react";
import {
  addGroup,
  deleteGroup,
  getAllGroup,
  getGroupByUser,
  getUsuariosByGroup,
  updateGroup,
} from "../../api/group";

import gruposReducer from "./gruposReducer";
import gruposContext from "./gruposContext";
import controlContext from "../../context/control/controlContext";

//Types
import {
  ACTUALIZAR_LIST_GROUP,
  MODIFICAR_GROUP,
  AGREGAR_GROUP,
  ELIMINAR_GROUP,
} from "./gruposActions";
import { sendNotificationPushByUserIdGroup } from "../../api/user";

//Socket
import { SocketContext } from "../socket/socket";

//Context authUser
import authContext from "../../context/authentication/authContex";

/* 
    State encargado de la gestión de usuarios.
*/
const GruposState = (props) => {
  const server = useContext(SocketContext);

  //Context control comprobantes
  const cContext = useContext(controlContext);
  const { filtrosEstado, modificarFiltrosEstado } = cContext;

  //Context auth
  const aContext = useContext(authContext);
  const { usuario, usuarioAutenticado } = aContext;

  const initialState = {
    gruposList: [],
  };

  const [state, dispatch] = useReducer(gruposReducer, initialState);

  const actualizarGroupList = async () => {
    try {
      const resp = await getAllGroup();
      const grupos = resp.data.data;

      dispatch({
        type: ACTUALIZAR_LIST_GROUP,
        payload: grupos,
      });
      return grupos;
    } catch (err) {
      console.log(err);
    }
  };

  const agregarGroup = async (grupo, usuariosId) => {
    try {
      const { name, cantUser } = grupo;
      const resp = await addGroup({ name, cantUser }, usuariosId);
      const grupos = resp.data.data;

      return { success: true, data: grupos };
    } catch (err) {
      console.log(err);
      const errorMessage = err.response?.data?.message || "Error al crear el grupo";
      return { success: false, message: errorMessage };
    }
  };

  const modificarGroup = async (id, updates) => {
    try {
      console.log(id);
      console.log(updates);
      const resp = await updateGroup(id, updates);
    } catch (err) {
      console.log(err);
    }
  };

  const eliminarGroup = async (id) => {
    try {
      console.log(id);
      const resp = await deleteGroup(id);
    } catch (err) {
      console.log(err);
    }
  };

  const enviarNotificacionPush = async (groupId, title, message) => {
    try {
      const resp = await sendNotificationPushByUserIdGroup(
        groupId,
        title,
        message
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (server) {
      //Grupo Nuevo
      server.on("addGroup", async (resp) => {
        console.log("NUEVO GRUPO GUARDADO", resp);
        if (!usuario || usuario == null) {
          await usuarioAutenticado();
        }
        await actualizarGroupList();
      });
      server.on("modGroup", async (resp) => {
        console.log("GRUPO MODIFICADO", resp);

        if (!usuario || usuario == null) {
          await usuarioAutenticado();
        }
        if (usuario) {
          const respGruposUsuario = await getGroupByUser(usuario._id);

          const gruposUsuarioIds = respGruposUsuario.data.data.map(
            (g) => g.grupo._id
          );
          const filtrosIds = filtrosEstado.gruposV.map((g) => g._id);

          const hayDiferencias =
            // Caso 1: grupo del usuario no está en filtros
            gruposUsuarioIds.some((id) => !filtrosIds.includes(id)) ||
            // Caso 2: grupo de filtros no está en usuario
            filtrosIds.some((id) => !gruposUsuarioIds.includes(id));

          if (hayDiferencias) {
            const gruposV = respGruposUsuario.data.data.map((g) => ({
              _id: g.grupo._id,
              name: g.grupo.name,
            }));
            //gruposV.push({ _id: "", name: ""});

            await modificarFiltrosEstado({ ...filtrosEstado, gruposV });
          }
        }

        dispatch({
          type: MODIFICAR_GROUP,
          payload: resp.data,
        });
      });

      server.on("deleteGroup", async (resp) => {
        console.log("GRUPO ELIMINADO", resp);
        if (!usuario || usuario == null) {
          await usuarioAutenticado();
        }
        await actualizarGroupList();
        dispatch({
          type: ELIMINAR_GROUP,
          payload: resp.data,
        });
      });

      return () => server.off(["addGroup", "modGroup", "deleteGroup"]);
    }
  }, [server]);

  return (
    <gruposContext.Provider
      value={{
        gruposList: state.gruposList,
        actualizarGroupList,
        agregarGroup,
        modificarGroup,
        eliminarGroup,
        enviarNotificacionPush,
      }}
    >
      {props.children}
    </gruposContext.Provider>
  );
};

export default GruposState;